import React, {useContext, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import Pane from '../../../../../components/pane/pane.component';
import {StyledNoOrders, StyledOrders} from './reports.style';
import {NoOrdersImage, ReportsImage} from "../../../../../utils/styles/icons";
import AddImage from '../../../../../assets/images/e-add.svg';
import AvatarImage from '../../../../../assets/images/logo/x-gray.png';
import ArrowRightImage from '../../../../../assets/images/arrow-right-black.svg';
import {StyledButton, StyledRedButton, StyledSocialButton} from '../../../../../components/button/button.style';
import {Links} from '../../../../links';
import CircleImage, {ImageTypes} from "../../../../../components/circleImage/circleImage.component";
import {StyledEmptyContainer} from "../../../../../components/content/content.style";
import {IonAlert, IonBadge, IonIcon, IonLoading, IonToast, useIonViewWillEnter} from "@ionic/react";
import {isEmployed} from "../../../../../services/auth.service";
import {log} from "../../../../../services/firebaseAnalytics.service";
import {Report, ReportWorker} from "../../../../../models/raport";
import {filtersToParams,} from "../../../../../services/report.service";
import {lockClosedOutline} from "ionicons/icons";
import {Filter} from "../../../../reportPage/components/filter/filterActionSheet.component";
import useNavigation from "../../../../../services/navigation.service";
import {Profile} from "../../../../../models/profile";
import {getPermission} from "../../../../../services/permission.service";
import {isMandatoryCourseCompleted} from "../../../../../services/course.service";
import ReportsSkeleton from "@app/mainPage/tabs/reports/components/reportsSkeleton.component";
import {getCurrentNetworkStatus, getOfflineDataStatus} from "../../../../../services/offlineSync.service";
import {Network} from "@capacitor/network";
import {
    getReports as getReportsFactory,
    removeReport as removeReportFactory
} from "../../../../../services/reportFactory.service";
import {ReportStatus} from "../../../../../enums/reportStatus";
import {EventType} from "../../../../../enums/eventType";
import {useEvent} from "../../../../../hooks/useEvent";
import {validate as validateUuid} from "uuid";
import {Preferences} from "@capacitor/preferences";
import {getLatestLocation, leave, postConfirmClient} from "@services/geolocation.service";
import LocationModal, {Location} from "@modals/location/location.component";
import Info from "@components/info/info.component";
import {ToastModel} from "types/toast";
import {Geolocation} from "@capacitor/geolocation";
import {AndroidSettings, IOSSettings, NativeSettings} from "capacitor-native-settings";
import {getNotAcceptedObligatoryNotifications} from "@services/push.service";
import NotAcceptedObligatoryNotificationsModal from "@app/reportPage/modals/notAcceptedObligatoryNotificationsModal.component";
import {Notification} from "@models/notification";
import {isEnableAddingInternalReports, isWorkerIdentityVerified} from "@utils/tools/worker";
import BulkReportsManagementModal from "../modals/bulkReportsManagementModal.component";
import ProcessingBanner from "@components/processingBanner/processingBanner.component";
import {getWorkerMonthlyHoursLimitStatus} from "@services/worker.service";

const MomentRange = require('moment-range');
const Moment = require('moment-timezone')
const moment = MomentRange.extendMoment(Moment);
const momentDurationFormatSetup = require("moment-duration-format");
momentDurationFormatSetup(moment);

type ReportsPaneProps = {
    topEdge?: number;
    status: string;
    filters?: Filter[];
    filtersName?: string[];
    profile?: Profile;
    refreshTrigger?: number;
    processingCount?: number;
    showProcessingFinished?: boolean;
    onProcessingRefresh?: () => void;
}

interface ReportsManager {
    setReports: Function;
    setFilters: Function;
    setNetworkStatus: Function;
}

const contextReports: ReportsManager = {
    setReports: () => {

    },
    setFilters: () => {

    },
    setNetworkStatus: () => {

    }
};

export const ReportsContext = React.createContext<ReportsManager>(contextReports);

const ReportsPane: React.FC<ReportsPaneProps> = (props: ReportsPaneProps) => {
    const {t} = useTranslation();

    const [loading, setLoading] = useState<boolean>(false);
    const [forceReload, setForceReload] = useState<boolean>(false);
    const [editPermission, setEditPermission] = useState<boolean>(false);
    const [reports, setReports] = useState<Report[] | undefined>(undefined);
    const [filters, setFilters] = useState<Filter[]>([]);
    const [showRemoveAlert, setShowRemoveAlert] = useState(false);
    const [showLeaveLocationAlert, setShowLeaveLocationAlert] = useState(false);
    const [toast, setToast] = useState<ToastModel>();
    const [selectedReport, setSelectedReport] = useState<Report | undefined>();
    const [hasReportsCourseCompleted, updateReportsCourseCompleted] = useState<boolean>(false);
    const [isAddingReportDisabled, setIsAddingReportDisabled] = useState<boolean>(true);
    const [addingReportDisabledReason, setAddingReportDisabledReason] = useState<string | undefined>(undefined);
    const [monthlyHoursLimitExceeded, setMonthlyHoursLimitExceeded] = useState<boolean>(false);
    const [notAcceptedObligatoryNotifications, setNotAcceptedObligatoryNotifications] = useState<Notification[] | undefined>(undefined);
    const [showNotAcceptedObligatoryNotificationsModal, setShowNotAcceptedObligatoryNotificationsModal] = useState<boolean>(false);

    const [networkStatus, setNetworkStatus] = useState(true);
    const isInitialMount = useRef(true);
    const [isOfflineDataReady, updateIsOfflineDataReady] = useState<boolean>(false)
    const [showLocationModal, updateShowLocationModal] = useState<boolean>(false);
    const [isInternalCostsReport, setIsInternalCostsReport] = useState<boolean>(false);
    const [latestLocation, setLatestLocation] = useState<Location>();
    const [needLocation, setNeedLocation] = useState<boolean>(false);
    const [showPermissionAlert, setShowPermissionAlert] = useState<boolean>(false);
    const [showLoading, updateShowLoading] = useState(false);
    const [showBulkManagementModal, setShowBulkManagementModal] = useState<boolean>(false);

    const contextReports = useContext(ReportsContext);
    contextReports.setReports = setReports;
    contextReports.setFilters = setFilters;
    contextReports.setNetworkStatus = setNetworkStatus;

    const [employed, setEmployed] = useState<boolean>(false);
    const [enableAddingInternalReports, setEnableAddingInternalReports] = useState<boolean>(false);

    const isEmployee = async() => {
        const response = await isEmployed();

        return response == '1';
    }

    const getEnableAddingInternalReports = async() => {
        return await isEnableAddingInternalReports() ;
    }

    const history = useHistory();
    const navigation = useNavigation(history);
    const {listen, dispatch, remove} = useEvent();

    useEffect(() => {
        handleIsAddingReportDisabled();
    }, [isOfflineDataReady, networkStatus, hasReportsCourseCompleted, employed, notAcceptedObligatoryNotifications]);

    useEffect(() => {
        if (props.profile) {
            return;
        }

        getWorkerMonthlyHoursLimitStatus()
            .then(status => setMonthlyHoursLimitExceeded(status.exceeded))
            .catch(() => setMonthlyHoursLimitExceeded(false));
    }, [props.profile]);

    const handleIsAddingReportDisabled = async () => {
        let networkStatus = await getCurrentNetworkStatus();
        let isOfflineDataReady = await getOfflineDataStatus()
            .then(response => {
                return response.valid;
            });

        if (!networkStatus && !isOfflineDataReady) {
            setIsAddingReportDisabled(true);
            setAddingReportDisabledReason('reportsTab.orders.disabledReason.noNetworkAndOfflineData');
            return;
        }

        if (!hasReportsCourseCompleted) {
            setIsAddingReportDisabled(true);
            setAddingReportDisabledReason('reportsTab.orders.disabledReason.courseNotCompleted');
            return;
        }

        if (!hasAcceptedObligatoryNotifications()) {
            setIsAddingReportDisabled(true);
            setAddingReportDisabledReason('reportsTab.orders.disabledReason.notificationsNotAccepted');
            setShowNotAcceptedObligatoryNotificationsModal(true);
            return;
        }

        if (employed) {
            const isIdentityVerified = await isWorkerIdentityVerified();

            if (!isIdentityVerified) {
                setIsAddingReportDisabled(true);
                setAddingReportDisabledReason('reportsTab.orders.disabledReason.identityNotVerified');
                return;
            }
        }

        setIsAddingReportDisabled(false);
        setAddingReportDisabledReason(undefined);
    }

    const navigationToParams = () => {
        let params: string[] = [];
        if (props.filtersName) {
            props.filtersName.forEach(value => {
                if (navigation.getParam(value)) {
                    params.push(value + '=' + navigation.getParam(value))
                }
            });
        }

        return params.join('&');
    }

    const fetchUserData = async () => {
        let isEmployed: boolean = await isEmployee();
        setEmployed(isEmployed);

        if (!props.profile){
            let isEnableAddingInternalReports: boolean = await getEnableAddingInternalReports();
            setEnableAddingInternalReports(isEnableAddingInternalReports);
        }
    }

    const fetchReportsCourseCompleted = async () => {
        if (!networkStatus && props.profile) {
            updateReportsCourseCompleted(false);
        } else {
            let isCompleted = await isMandatoryCourseCompleted();
            updateReportsCourseCompleted(isCompleted);
        }
    }

    const fetchNotAcceptedObligatoryNotifications = async () => {
        const notifications = await getNotAcceptedObligatoryNotifications();

        setNotAcceptedObligatoryNotifications(notifications);
    }

    const hasAcceptedObligatoryNotifications = (): boolean => {
        if (!notAcceptedObligatoryNotifications || notAcceptedObligatoryNotifications.length === 0) {
            return true;
        }

        return false;
    }

    const fetchReports = async (params: any = null) => {
        if ((reports === undefined && !loading) || forceReload) {
            setLoading(true);
            setReports([]);
            const tmpReports: Report[] = await getReportsFactory(props.status, params)
                .then(response => {
                    return response;
                })
                .catch(reason => {
                    return [];
                });

            setReports(tmpReports);
            setLoading(false);
            setForceReload(false)
        }
    }

    const fetchPermission = async () => {
        if (props.profile) {
            if (networkStatus) {
                await getPermission('REPORTS', 'EDIT')
                    .then(response => {
                        setEditPermission(response.data);
                    })
            } else {
                setEditPermission(true);
            }
        }
    }

    useEffect(() => {
        const handleReload = () => {
            setForceReload(true)
        };

        const handleLocation = () => {
            checkLocationNeed();
            setForceReload(true);
        };

        listen(EventType['REPORT.LIST.RELOAD'], handleReload);
        listen(EventType["REPORT.LIST.LOCATION"], handleLocation);

        return () => {
            remove(EventType['REPORT.LIST.RELOAD'], handleReload);
            remove(EventType["REPORT.LIST.LOCATION"], handleLocation);
        };
    }, []);

    // Pobierz dane przy wejściu na stronę i przy powrocie (refreshTrigger zmienia się z 0 na 1, 2, ...)
    useEffect(() => {
        if (!props.refreshTrigger) {
            return; // refreshTrigger = 0 przy pierwszym renderze, czekamy na useIonViewWillEnter
        }
        fetchPermission();
        fetchUserData();
        fetchReportsCourseCompleted();
        fetchNotAcceptedObligatoryNotifications();
        setForceReload(true); // Wymusza pobranie raportów nawet gdy już były pobrane
        checkLocationNeed();

        // Ustaw flagę na false po pierwszym renderze
        setTimeout(() => {
            isInitialMount.current = false;
        }, 0);
    }, [props.refreshTrigger]);

    useEffect(() => {
        if (forceReload) {
            fetchReports(navigationToParams());
            setForceReload(false);
        }
    }, [forceReload]);

    useEffect(() => {
        fetchPermission();
    }, [props.profile]);

    useEffect(() => {
        if (filtersToParams(filters)) {
            setForceReload(true);
        }
    }, [filters]);


    useEffect(() => {
        if (isInitialMount.current) {
            return;
        }
        const updateOfflineDataStatus = async () => {
            await getOfflineDataStatus()
                .then(response => {
                    updateIsOfflineDataReady(response.valid);
                });
        }

        updateOfflineDataStatus();
        setForceReload(true);
        fetchReports(navigationToParams());
        fetchReportsCourseCompleted();
        fetchNotAcceptedObligatoryNotifications();
        fetchPermission();
        checkLocationNeed();
    }, [networkStatus]);

    useEffect(() => {
        const getCurrentNetworkStatus = async () => {
            await Network.getStatus()
                .then(result => {
                    setNetworkStatus(result.connected)
                });
        };

        getCurrentNetworkStatus();
    }, []);

	useEffect(() => {
		log('page_visit', {
			page: 'Raporty -> Raporty'
		});
	}, []);

    useEffect(() => {
        checkLocationNeed();
	}, []);

    const checkLocationNeed = async () => {
        let localizationAvailable = await Preferences.get({
            'key': 'localization_available'
        });
        setLatestLocation(undefined);
        setNeedLocation(false);

        const networkStatus = await getCurrentNetworkStatus();
        if (networkStatus && localizationAvailable.value == '1') {
            let latest = await getLatestLocation().then(response => {
                return response.data as Location;
            }).catch(reason => {
                return null;
            });

            if (!latest) {
                setNeedLocation(true);
                return true;
            } else {
                setLatestLocation(latest);
                setNeedLocation(false);
            }
        } else {
            setNeedLocation(false);
        }

        return false;
    }

    const addReport = async (internalCosts = false) => {
        let locationNeed = await checkLocationNeed();

        if (locationNeed) {
            setIsInternalCostsReport(internalCosts);
            updateShowLocationModal(true);
        } else {
            history.push(Links.qrCodeSpecification + '/' + (internalCosts ? '1' : '0'));
        }
    };

    useEffect(() => {
		log('page_visit', {
			page: 'Raporty -> Raporty'
		});
	}, []);

    const removeDraft = async (report: Report) => {
        await removeReportFactory(report.id.toString(), report.offline);
        setForceReload(true);
    }

    return (
        <Pane topEdge={props.topEdge} marginTop={40} paddingBottom={147}>
            {
                !employed && !props.profile &&
                <StyledEmptyContainer>
                    <CircleImage image={ImageTypes.REPORTS} color="grey"/>
                        <h3>{t('reportsTab.orders.soonAvailableNotWorker')}</h3>
                </StyledEmptyContainer>
            }
            {
                (employed || props.profile) &&
                    <>
                        {latestLocation && networkStatus && <span onClick={() => setShowLeaveLocationAlert(true)}><Info>{t("reportsTab.location.leave")}: {latestLocation.client.name}</Info> <br /></span>}
                        {!props.profile && monthlyHoursLimitExceeded && (
                            <>
                                <Info className="warning centered">{t('reportsTab.orders.monthlyHoursLimitExceededInfo')}</Info>
                                <br />
                            </>
                        )}
                        {
                            ((!props.profile || (props.profile && editPermission))) &&
                            <>
                                <StyledSocialButton id="reports-add-report" className={isAddingReportDisabled ? 'inverted disabled' : 'inverted'} disabled={isAddingReportDisabled} onClick={() => addReport()} >
                                    {/* @todo disabled={!networkStatus && !isOfflineDataReady && !hasReportsCourseCompleted} bo był bug i nie działa mi z tym coś pobugowane pamiętac o tym*/}
                                    <img src={AddImage}/>
                                    {t('reportsTab.orders.addReportButton')}
                                </StyledSocialButton>
                                {(props.profile || enableAddingInternalReports) && (
                                    <>
                                        <br />
                                        <StyledSocialButton className={isAddingReportDisabled ? 'inverted disabled' : 'inverted'} disabled={isAddingReportDisabled} onClick={() => addReport(true)} >
                                            {/* @todo disabled={!networkStatus && !isOfflineDataReady && !hasReportsCourseCompleted} bo był bug i nie działa mi z tym coś pobugowane pamiętac o tym*/}
                                            <img src={AddImage}/>
                                            {t('reportsTab.orders.addInternalCostsReportButton')}
                                        </StyledSocialButton>
                                    </>
                                )}
                                {isAddingReportDisabled && addingReportDisabledReason && (
                                    <>
                                        <br />
                                        <Info className="warning centered">{t(addingReportDisabledReason)}</Info>
                                    </>
                                )}
                            </>
                        }
                        {
                            !props.profile && props.status === 'DRAFT' &&
                            <>
                                <br />
                                <StyledSocialButton
                                    className={(!reports || reports.length === 0 || !reports.some(r => r.is_editable)) ? 'inverted disabled' : 'inverted'}
                                    disabled={!reports || reports.length === 0 || !reports.some(r => r.is_editable)}
                                    onClick={() => setShowBulkManagementModal(true)}
                                >
                                    {t('reportsTab.bulkManagement.button')}
                                </StyledSocialButton>
                                {(!reports || reports.length === 0) && (
                                    <>
                                        <br />
                                        <Info className="warning centered">{t('reportsTab.bulkManagement.disabledReason.noReports')}</Info>
                                    </>
                                )}
                                {reports && reports.length > 0 && !reports.some(r => r.is_editable) && (
                                    <>
                                        <br />
                                        <Info className="warning centered">{t('reportsTab.bulkManagement.disabledReason.noEditableReports')}</Info>
                                    </>
                                )}
                            </>
                        }
                        {props.processingCount !== undefined && (props.processingCount > 0 || props.showProcessingFinished) && (
                            <>
                                <br />
                                <ProcessingBanner
                                    count={props.processingCount}
                                    bannerText={t('reportsTab.processing.banner', { count: props.processingCount })}
                                    refreshText={t('reportsTab.processing.refresh')}
                                    showFinished={props.showProcessingFinished ?? false}
                                    onRefresh={props.onProcessingRefresh ?? (() => {})}
                                />
                            </>
                        )}
                        {
                            !loading && reports && reports.length === 0 &&
                            <StyledNoOrders>
                                {/* hide showJobOpportunitiesButton */}
                                <img src={NoOrdersImage}/>
                                <img className="reports" src={ReportsImage}/>
                                <span className="message">{t('reportsTab.orders.noReports')}</span>
                                {
                                    employed &&
                                    <StyledSocialButton className={!networkStatus ? 'auto-width disabled' : 'auto-width'} disabled={!networkStatus} onClick={() => history.push(Links.main+Links.offers)}>
                                        {t('reportsTab.orders.showJobOpportunitiesButton')}
                                    </StyledSocialButton>
                                }
                            </StyledNoOrders>
                        }
                        {
                            !loading && reports && reports.length !== 0 &&
                            <StyledOrders>
                                {
                                    reports.map((report: Report, i) => {
                                        let date = moment(report.service_date, moment.ISO_8601).tz('Europe/Warsaw');
                                        const previous: Report = reports[i - 1];
                                        let prevDate = previous && previous.service_date ? moment(previous.service_date, moment.ISO_8601).tz('Europe/Warsaw') : null;

                                        let sameDate = false;
                                        if (prevDate && date.format('DD.MM.YYYY') === prevDate?.format('DD.MM.YYYY')) {
                                            sameDate = true;
                                        }

                                        return <React.Fragment key={i}>
                                                {!sameDate && <div className="date-separator">
                                                    <div className="box">{date.format('DD.MM.YYYY')}</div>
                                                </div>}
                                                <div className="order">
                                                    {report.need_location_change && networkStatus && <><Info className="error">{t("reportsTab.location.need_change")}</Info><br /></>}

                                                    <div className="order-number" onClick={async () => {
                                                        if ((!props.profile && report.status !== 'OPEN' && report.status !== ReportStatus.OFFLINE_DRAFT && report.status !== ReportStatus.OFFLINE_READY_TO_SYNC && report.status !== ReportStatus.OFFLINE_SYNC_ERROR) || props.profile) {
                                                            if ((!props.profile && report.is_editable) || (props.profile && editPermission)) {
                                                                if (needLocation || report.need_location_change) {
                                                                    await postConfirmClient(report.place_of_service_id).then(() => {
                                                                        history.push(`${Links.report}/${report.order.id}/${(report.ep2_scanned_specification_id ? report.ep2_scanned_specification_id : (report.order.specification ? report.order.specification.id: '0'))}/${report.id}/0/0/${report.internal_costs_type ? '1' : '0'}`);
                                                                    }).catch(() => {
                                                                        setToast({
                                                                            message: t('locationModal.gpsLocation.error'),
                                                                            type: 'danger'
                                                                        });                                                                    });
                                                                } else {
                                                                    history.push(`${Links.report}/${report.order.id}/${(report.ep2_scanned_specification_id ? report.ep2_scanned_specification_id : (report.order.specification ? report.order.specification.id: '0'))}/${report.id}/0/0/${report.internal_costs_type ? '1' : '0'}`);
                                                                }
                                                            } else {
                                                                history.push(`${Links.report}/${report.order.id}/${(report.ep2_scanned_specification_id ? report.ep2_scanned_specification_id : (report.order.specification ? report.order.specification.id: '0'))}/${report.id}/1/0/${report.internal_costs_type ? '1' : '0'}`);
                                                            }
                                                        }

                                                        if (report.status === ReportStatus.OFFLINE_DRAFT || report.status === ReportStatus.OFFLINE_SYNC_ERROR) {
                                                            history.push(`${Links.report}/${report.order.id}/${(report.ep2_scanned_specification_id ? report.ep2_scanned_specification_id : (report.order.specification ? report.order.specification.id: '0'))}/${report.id}/0_offline/0/${report.internal_costs_type ? '1' : '0'}`);
                                                        }
                                                    }}>
                                                        {(report.status !== ReportStatus.OFFLINE_DRAFT && report.status !== ReportStatus.OFFLINE_SYNC_ERROR && !report.is_editable && !props.profile) && <IonIcon src={lockClosedOutline} style={{"height": "15px", "fontSize": "14px", "color": '#888A98', "paddingRight": "10px"}} />}
                                                        {t('reportsTab.orders.report')} {report.formatted_number} { ((report.status !== 'OPEN' || props.profile) && report.is_editable) && <img src={ArrowRightImage}/> }
                                                        {report.status === 'DRAFT' && <><br /><IonBadge color="warning" className="draft">{t('reportsTab.orders.status.draft')}</IonBadge></>}
                                                        {report.status === 'NOT_VERIFIED' && <><br /><IonBadge color="warning" className="draft">{t('reportsTab.orders.status.not_verified')}</IonBadge></>}
                                                        {report.status === 'OPEN' && <><br /><IonBadge color="success" className="draft">{t('reportsTab.orders.status.verified')}</IonBadge></>}
                                                        {report.status === ReportStatus.OFFLINE_DRAFT && <><br /><IonBadge color="warning" className="draft">{t(!report.multiple_orders ? (!report.online_backup ? 'reportsTab.orders.status.offline' : 'reportsTab.orders.status.offline_backup') : 'reportsTab.orders.status.multiple_orders_offline')}</IonBadge></>}
                                                        {report.status === ReportStatus.OFFLINE_READY_TO_SYNC && <><br /><IonBadge color="warning" className="draft">{t('reportsTab.orders.status.offline_ready_to_sync')}</IonBadge></>}
                                                        {report.status === ReportStatus.OFFLINE_SYNC_ERROR && <><br /><IonBadge color="danger" className="draft">{t('reportsTab.orders.status.sync_error')}</IonBadge></>}
                                                        {report.internal_costs_type && <> <IonBadge color="warning" className="draft">{t('reportsTab.orders.internal_costs_report')}</IonBadge></>}
                                                    </div>
                                                    <div className="members">
                                                        {
                                                            (report.status !== 'OPEN' || props.profile) && report.workers && report.workers.length > 0 && report.workers.map((person: ReportWorker, i) =>
                                                                <img
                                                                    src={person.user && (person.user?.photos || person.user?.avatar) ? (person.user.photos?.thumbnail ? person.user.photos.thumbnail : person.user.avatar) : AvatarImage}
                                                                    key={i}/>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="details">
                                                        {report.components.numbers.join(',') &&
                                                        <div
                                                            className="detail">{t('reportsTab.orders.componentsNumbers')}<span
                                                            className="value">{report.components.numbers.join(',')}</span>
                                                        </div>}
                                                        {report.components.names.join(',') &&
                                                        <div
                                                            className="detail">{t('reportsTab.orders.componentsNames')}<span
                                                            className="value">{report.components.names.join(',')}</span>
                                                        </div>}
                                                        <div className="detail">{t('reportsTab.orders.placeOfService')}<span
                                                            className="value">{report.place_of_service}</span></div>
                                                        {report.order_factory_number &&
                                                        <div className="detail">{t('reportsTab.orders.factoryNumber')}<span
                                                            className="value">{report.order_factory_number}</span></div>}
                                                        {report.order.complaint_number &&
                                                        <div className="detail">{t('reportsTab.orders.complaintNumber')}: <span
                                                            className="value">{report.order.complaint_number}</span></div>}
                                                        {report.checked_parts_sum > 0 && <div className="detail">
                                                            {t('reportsTab.orders.componentsSum')}
                                                            <span className="value">
                                                                {report.checked_parts_sum}
                                                            </span>
                                                        </div>}
                                                        { (report.status !== 'OPEN' || props.profile) && report.limits && report.limits.type === 'PARTS_QUANTITY' &&
                                                            <div className="detail">{t('reportsTab.orders.partsLimitAlreadyUsed')}: <span className={"value" + " " + report.limits.textClass}>
                                                                    {report.limits.current} / {report.limits.value}
                                                                </span>
                                                            </div>
                                                        }
                                                        { (report.status !== 'OPEN' || props.profile) && report.hours_sum_humanized &&
                                                            <div className="detail">
                                                                {t('reportsTab.orders.reportedHours')}
                                                                <span className="value">
                                                                {report.hours_sum_humanized}
                                                            </span>
                                                            </div>
                                                        }
                                                        { (report.status !== 'OPEN' || props.profile) && report.limits && report.limits.type === 'HOURS_LIMIT' &&
                                                            <div className="detail">{t('reportsTab.orders.hoursLimitAlreadyUsed')}: <span className={"value" + " " + report.limits.textClass}>
                                                                    {report.limits.current} / {report.limits.value}
                                                                </span>
                                                            </div>
                                                        }
                                                        { (report.status !== 'OPEN' || props.profile) && report.order.specification && report.avg_time_per_component &&
                                                        <div
                                                            className="detail">{t('reportsTab.orders.averageInspectionTime')}<span
                                                            className="value">{report.avg_time_per_component}s</span></div>}

                                                        <div className="detail">
                                                            {t('reportsTab.orders.createdBy')}
                                                            <span className="value">
                                                                {report.created_by}
                                                            </span>
                                                        </div>

                                                    </div>

                                                    {report.status === 'DRAFT' && ((!props.profile && report.is_editable) || (props.profile && editPermission && report.is_editable)) &&
                                                        <>
                                                            <StyledButton onClick={async () => {
                                                                if (needLocation || report.need_location_change) {
                                                                    await postConfirmClient(report.place_of_service_id).then(() => {
                                                                            history.push(`${Links.report}/${report.order.id}/${(report.ep2_scanned_specification_id ? report.ep2_scanned_specification_id : (report.order.specification ? report.order.specification.id: '0'))}/${report.id}/0/0/${report.internal_costs_type ? '1' : '0'}`);
                                                                        }).catch(() => {
                                                                            setToast({
                                                                                message: t('locationModal.gpsLocation.error'),
                                                                                type: 'danger'
                                                                            });
                                                                        });
                                                                } else {
                                                                    history.push(`${Links.report}/${report.order.id}/${(report.ep2_scanned_specification_id ? report.ep2_scanned_specification_id : (report.order.specification ? report.order.specification.id: '0'))}/${report.id}/0/0/${report.internal_costs_type ? '1' : '0'}`);
                                                                }
                                                            }}>
                                                                {t('reportsTab.orders.continue')}
                                                            </StyledButton>
                                                        </>
                                                    }

                                                    {report.status === ReportStatus.OFFLINE_DRAFT &&
                                                        <>
                                                            <StyledButton onClick={() => {
                                                                history.push(`${Links.report}/${report.order.id}/${(report.ep2_scanned_specification_id ? report.ep2_scanned_specification_id : (report.order.specification ? report.order.specification.id: '0'))}/${report.id}/0_offline/0/${report.internal_costs_type ? '1' : '0'}`);
                                                            }}>
                                                                {t('reportsTab.orders.continue')}
                                                            </StyledButton>
                                                        </>
                                                    }

                                                    {report.status === 'DRAFT' && !props.profile && report.is_editable && (report.order.is_extended_reporting || report.is_worker_report_delation_enabled) &&
                                                        <>
                                                            <StyledRedButton onClick={() => {
                                                                setSelectedReport(report);
                                                                setShowRemoveAlert(true);
                                                            }}>
                                                                {t('reportsTab.orders.remove')}
                                                            </StyledRedButton>
                                                        </>
                                                    }

                                                    {report.status === ReportStatus.OFFLINE_DRAFT && validateUuid(report.id.toString()) &&
                                                        <>
                                                            <StyledRedButton onClick={() => {
                                                                setSelectedReport(report);
                                                                setShowRemoveAlert(true);
                                                            }}>
                                                                {t('reportsTab.orders.remove')}
                                                            </StyledRedButton>
                                                        </>
                                                    }

                                                    {report.status === ReportStatus.OFFLINE_SYNC_ERROR &&
                                                        <>
                                                            <StyledButton onClick={() => {
                                                                history.push(`${Links.report}/${report.order.id}/${(report.ep2_scanned_specification_id ? report.ep2_scanned_specification_id : (report.order.specification ? report.order.specification.id: '0'))}/${report.id}/0_offline/0/${report.internal_costs_type ? '1' : '0'}`);
                                                            }}>
                                                                {t('reportsTab.orders.continue')}
                                                            </StyledButton>
                                                        </>
                                                    }

                                                    {report.status === ReportStatus.OFFLINE_SYNC_ERROR && validateUuid(report.id.toString()) &&
                                                        <>
                                                            <StyledRedButton onClick={() => {
                                                                setSelectedReport(report);
                                                                setShowRemoveAlert(true);
                                                            }}>
                                                                {t('reportsTab.orders.remove')}
                                                            </StyledRedButton>
                                                        </>
                                                    }
                                                </div>
                                            </React.Fragment>
                                        }
                                    )
                                }
                            </StyledOrders>
                        }
                        {
                            loading && <ReportsSkeleton/>
                        }
                    </>
            }

            <IonAlert
                isOpen={showRemoveAlert}
                onDidDismiss={() => {
                    setSelectedReport(undefined);
                    setShowRemoveAlert(false);
                }}
                header={t('common.alertHeader')}
                buttons={[
                    {
                        text: t('common.alertCancel'),
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            setShowRemoveAlert(false);
                        }
                    },
                    {
                        text: t('common.alertConfirm'),
                        handler: () => {
                            if (selectedReport) {
                                removeDraft(selectedReport);
                            }
                        }
                    }
                ]}
            />

            <IonAlert
                isOpen={showLeaveLocationAlert}
                onDidDismiss={() => {
                    setShowLeaveLocationAlert(false)
                }}
                header={t('common.alertHeader')}
                subHeader={latestLocation ? t("reportsTab.location.leave") + ':' + latestLocation.client.name : t("reportsTab.location.leave")}
                buttons={[
                    {
                        text: t('common.alertCancel'),
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            setShowLeaveLocationAlert(false);
                        }
                    },
                    {
                        text: t('common.alertConfirm'),
                        handler: async () => {
                            updateShowLoading(true)
                            setShowLeaveLocationAlert(false);

                            let hasPermissions = await Geolocation.checkPermissions()
                                .then((location) => {
                                    return location.location;
                                })
                                .catch(reason => {
                                    return 'error';
                                });

                            if (hasPermissions === 'denied' || hasPermissions === 'error') {
                                setShowPermissionAlert(true);
                            } else {
                                await leave()
                                    .then((response) => {
                                        checkLocationNeed();
                                        dispatch(EventType['REPORT.LIST.RELOAD'])
                                    })
                                    .catch(reason => {
                                        setToast({
                                            message: t('locationLeaveModal.error'),
                                            type: 'danger'
                                        });
                                    })
                            }

                            updateShowLoading(false)
                        }
                    }
                ]}
            />

            <IonAlert
                isOpen={showPermissionAlert}
                onDidDismiss={() => setShowPermissionAlert(false)}
                header={t('common.geolocation_permissions.alert')}
                buttons={[
                    {
                        text: t('common.alertCancel'),
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            setShowPermissionAlert(false);
                        },
                    },
                    {
                        text: t('common.geolocation_permissions.goToAppSettings'),
                        handler: async () => {
                            setShowPermissionAlert(false);
                            await NativeSettings.open({
                                optionAndroid: AndroidSettings.ApplicationDetails,
                                optionIOS: IOSSettings.App
                            })
                        }
                    }
                ]}
            />

            <IonToast
                isOpen={!!toast}
                onDidDismiss={() => setToast(undefined)}
                message={toast?.message}
                duration={toast?.duration ? toast.duration : 6000}
                position="top"
                color={toast?.type}
            />

            <LocationModal
                isOpen={showLocationModal}
                onClose={() => updateShowLocationModal(false)}
                onSuccess={() => {
                    updateShowLocationModal(false)
                    history.push(Links.qrCodeSpecification + '/' + (isInternalCostsReport ? '1' : '0'));
                }}
            />

            <NotAcceptedObligatoryNotificationsModal
                isOpen={showNotAcceptedObligatoryNotificationsModal}
                onSuccess={async () => {
                    setShowNotAcceptedObligatoryNotificationsModal(false);
                    await fetchNotAcceptedObligatoryNotifications();
                }}
                onClose={async () => {
                    setShowNotAcceptedObligatoryNotificationsModal(false);
                }}
            />

            <BulkReportsManagementModal
                isOpen={showBulkManagementModal}
                onClose={() => setShowBulkManagementModal(false)}
                onSuccess={() => {
                    setShowBulkManagementModal(false);
                    setForceReload(true);
                }}
                reports={(reports || []).filter(r => r.is_editable)}
            />

            <IonLoading onDidDismiss={() => updateShowLoading(false)} isOpen={showLoading}/>
        </Pane>
    );
};

export default ReportsPane;
